import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import type { MenuItem } from './main-menu-config.type';
import { IsFunctionPipe, IsStringPipe } from '@pct/ng-common';
import { CustomMatSvgIconDirective } from '../common/custom-mat-svg-icon/custom-mat-svg-icon.directive';
import { ResolveTranslateAbleTextPipe } from '@pct/ng-i18n';
import type { AdminUserRole } from '../../backend/main';

@Component({
  selector: 'app-layout-menu',
  imports: [
    MatMenu,
    MatButton,
    MatIcon,
    MatMenuTrigger,
    IsFunctionPipe,
    IsStringPipe,
    MatMenuItem,
    RouterLink,
    MatMenuContent,
    CustomMatSvgIconDirective,
    ResolveTranslateAbleTextPipe,
  ],
  templateUrl: './menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  readonly mainLabelText = input.required<string>();
  readonly items = input.required<MenuItem<AdminUserRole>[]>();
}
